import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import './SelectMovieColumnArea.css'
//import Button from '@material-ui/core/Button'


const wStyles = theme => ({

})

class SelectMovieColumnArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
            columnStatus:null
        }
    }

    componentDidMount(){
        this.initialState()
    }

    initialState=()=>{
        if(this.props.columnStatus)
        {
            this.setState({
                columnStatus:this.props.columnStatus
            })
        }
    }

    componentDidUpdate(prevProps,prevState){

    }

    componentWillUnmount(){
        this.props.getColumnStatus(this.state.columnStatus)
    }

    getFirstGroupCell=()=>{
        return( 
            <div style={{display:"flex"}}>
                <div style={{width:"100px",margin:"5px",padding:"5px"}}>影片名稱</div>
                <div className={this.state.columnStatus && this.state.columnStatus[3-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(3)}>翻譯片名</div>
                <div className={this.state.columnStatus && this.state.columnStatus[4-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(4)}>其他片名</div>
            </div>
        )
    }

    getSecondGroupCell=()=>{
        return( 
            <div style={{display:"flex"}}>
                <div style={{width:"100px",margin:"5px",padding:"5px"}}>種類</div>
                <div className={this.state.columnStatus && this.state.columnStatus[1-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(1)}>長短片</div>
                <div className={this.state.columnStatus && this.state.columnStatus[2-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(2)}>種類</div>
            </div>
        )
    }

    getThirdGroupCell=()=>{
        return( 
            <div style={{display:"flex"}}>
                <div style={{width:"100px",margin:"5px",padding:"5px"}}>出品資訊</div>
                <div className={this.state.columnStatus && this.state.columnStatus[5-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(5)}>出品年代</div>
                <div className={this.state.columnStatus && this.state.columnStatus[6-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(6)}>出品地點</div>
                <div className={this.state.columnStatus && this.state.columnStatus[7-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(7)}>出品公司</div>
                <div className={this.state.columnStatus && this.state.columnStatus[8-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(8)}>出品人</div>
            </div>
        )
    }

    getFourthGroupCell=()=>{
        return( 
            <div style={{display:"flex"}}>
                <div style={{width:"100px",margin:"5px",padding:"5px"}}>故事大綱</div>
                <div className={this.state.columnStatus && this.state.columnStatus[9-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(9)}>故事大綱</div>
            </div>
        )
    }

    getFifthGroupCell=()=>{
        return( 
            <div style={{display:"flex"}}>
                <div style={{width:"100px",margin:"5px",padding:"5px"}}>電影證照</div>
                <div className={this.state.columnStatus && this.state.columnStatus[10-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(10)}>電影分級</div>
            </div>
        )
    }

    getSixthGroupCell=()=>{
        return( 
            <div style={{display:"flex"}}>
                <div style={{width:"100px",margin:"5px",padding:"5px"}}>語言</div>
                <div className={this.state.columnStatus && this.state.columnStatus[11-1].status? "selectedColumnCell":"unselectedColumnCell"} onClick={()=>this.toggleColumn(11)}>語言</div>
            </div>
        )
    }

    toggleColumn=(id)=>{
        let tempArray = this.state.columnStatus.map(column=>{
            if(column.columnID === id)
            {
                let tempObj = {
                    columnID:column.columnID,
                    columnName:column.columnName,
                    columnTitle:column.columnTitle,
                    width:column.width,
                    status:!column.status
                }
                return tempObj
            }
            else
            {
                return column
            }
        })

        this.setState({
            columnStatus:tempArray
        })
    }




    render(){
        //const {classes} = this.props;
        let maskStyle = {
            position:"absolute", 
            top:"0px",
            width:"100%", 
            height:"100%",
            zIndex:"10", 
            backgroundColor:"#ffffff8f"
        }

        let contianStyle = {
            position:"absolute",
            left:"20px",
            top:"180px",
            //width:"400px",
            //height:"200px",
            backgroundColor:"#85e4ca",
            borderRadius:"5px",
            boxShadow:"2px 2px 10px grey"
        }
    
        return(
            <div style={maskStyle}>
                <div style={contianStyle}>
                    <div className ={"rightTopBoxArea"}>
                        <div className = {"rightTopBox"} onClick={()=>this.props.closeColumnSelectedModal(false)}>{"X"}</div>
                    </div>
                    <div>
                        <div style={{margin:"5px"}}>選擇列表頁顯示的欄位</div>
                        {this.getFirstGroupCell()}
                        {this.getSecondGroupCell()}
                        {this.getThirdGroupCell()}
                        {this.getFourthGroupCell()}
                        {this.getFifthGroupCell()}
                        {this.getSixthGroupCell()}
                    </div>
                </div>
            </div>
            
            
        )
    }

}

export default withStyles(wStyles)(SelectMovieColumnArea)